import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175b462e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resource_title" }, "资源类型：", -1))
const _hoisted_3 = { class: "resource_radio" }
const _hoisted_4 = { class: "resource_title_tip" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resource_title" }, "资源配置：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "并发：账户下所有直播间同时在线观看直播和回放的最高人数", -1))
const _hoisted_7 = { class: "resource_radio" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resource_title" }, "资源时长：", -1))
const _hoisted_9 = { class: "resource_radio" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resource_title" }, "生效时间：", -1))
const _hoisted_11 = { class: "resource_radio" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resource_title" }, "购买数量：", -1))
const _hoisted_13 = { class: "resource_radio" }
const _hoisted_14 = { class: "resource_buttom" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resource_buttom_title" }, "应付款：", -1))
const _hoisted_16 = { class: "resource_buttom_money" }

import { ref } from 'vue';
import http from '@/api/resource';
import { useRoute, useRouter } from 'vue-router';
import moment, { Moment } from 'moment';
import { Radio, InputNumber, message, Popover, DatePicker } from 'ant-design-vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
interface termType {
  term_name: string;
  term_type: number;
  term_price: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OldResourceBuy',
  setup(__props) {

const router = useRouter();
const aRadioGroup = Radio.Group;
const aRadioButton = Radio.Button;
const aInputNumber = InputNumber;
const aPopover = Popover;
const aDatePicker = DatePicker;
const route = useRoute();
const pageIndex = route.query.pageIndex;

const effectDate = ref();
effectDate.value = moment(new Date());
const disabledDate = (current: Moment) => {
  return current < moment().endOf('day').subtract(1, 'days');
};
// 获取资源包类型
const packTypeList: any = ref([]);
const typeValue = ref();
const getPackTypes = () => {
  http.getPackType().then((res) => {
    packTypeList.value = [...res.data.data];
    typeValue.value = pageIndex ? Number(pageIndex) : packTypeList.value[0].package_index;
    getPackIndex();
  });
};
// 获取资源包名称、时长
const packIndexList: any = ref([]);
const packIndexValue = ref();
const termList = ref<termType[]>([]);
const termValue: any = ref();
const getPackIndex = () => {
  let data = {
    package_index: typeValue.value,
  };
  http.getPackByIndex({ params: data }).then((res) => {
    packIndexList.value = [...res.data.data];
    packIndexValue.value = packIndexList.value[0].id;
    termList.value = packIndexList.value[0].term;
    termValue.value = termList.value[0].term_type;
    payInfo();
  });
};
getPackTypes();
// 获取资源包时长
const getTermIndex = () => {
  let filterList: any = [];
  filterList = packIndexList.value.filter((res: any) => {
    return res.id == packIndexValue.value;
  });
  termList.value = [];
  termList.value = filterList[0].term;
  termValue.value = termList.value[0].term_type;
  payInfo();
};

// 数量
const buyNum = ref<number>(1);
// 获取价格
const paymentAmount = ref<number>(0);
const payInfo = () => {
  buyNum.value ? '' : (buyNum.value = 1);
  const data = {
    id: packIndexValue.value,
    term_type: termValue.value,
    count: buyNum.value,
  };
  http.payPackageInfo({ params: data }).then((res) => {
    paymentAmount.value = res.data.data.amount;
  });
};

// 下一步
const toNext = () => {
  message.destroy();
  router.push({
    name: 'WalletPay',
    params: {
      goods_id: '0-' + packIndexValue.value,
    },
    query: {
      id: packIndexValue.value,
      term_type: termValue.value,
      count: buyNum.value,
      start_at: moment(effectDate.value).format('YYYY-MM-DD HH:mm:ss'),
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(aRadioGroup), {
        value: typeValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((typeValue).value = $event)),
        onChange: getPackIndex
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packTypeList.value, (item) => {
            return (_openBlock(), _createBlock(_unref(aRadioButton), {
              key: item.package_index,
              class: "resource_radio_button",
              value: item.package_index
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (typeValue.value == 1 || typeValue.value == 10 ? true : false)
        ? (_openBlock(), _createBlock(_unref(aPopover), {
            key: 0,
            placement: "right",
            class: "resource_tip"
          }, {
            content: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(aRadioGroup), {
        value: packIndexValue.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((packIndexValue).value = $event)),
        onChange: getTermIndex
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packIndexList.value, (item) => {
            return (_openBlock(), _createBlock(_unref(aRadioButton), {
              key: item.id,
              class: "resource_radio_button",
              value: item.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(aRadioGroup), {
        value: termValue.value,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((termValue).value = $event)),
        onChange: payInfo
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(termList.value, (item) => {
            return (_openBlock(), _createBlock(_unref(aRadioButton), {
              key: item.term_type,
              class: "resource_radio_button",
              value: item.term_type
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.term_name), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(aDatePicker), {
        "show-time": { format: 'HH:mm:ss' },
        format: "YYYY-MM-DD HH:mm:ss",
        value: effectDate.value,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((effectDate).value = $event)),
        class: "mod_range_picker",
        "disabled-date": disabledDate,
        allowClear: false
      }, {
        suffixIcon: _withCtx(() => [
          _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_unref(aInputNumber), {
        min: 1,
        value: buyNum.value,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((buyNum).value = $event)),
        parser: (value) => value.replace(/[^0-9]/g, ''),
        onChange: payInfo
      }, null, 8, ["value", "parser"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, "￥" + _toDisplayString(paymentAmount.value), 1),
      _createVNode(_component_a_button, {
        type: "primary",
        class: "resource_buttom_btn",
        onClick: toNext
      }, {
        default: _withCtx(() => [
          _createTextVNode("下一步")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})